import React from "react";
import { Box, Typography } from "@mui/material";

interface Container {
  title: string;
  hideTitle?: boolean;
  children: React.ReactNode;
}

// eslint-disable-next-line import/prefer-default-export
export function Container({ title, children, hideTitle = false }: Container): React.JSX.Element {
  return (
    <Box>
      {!hideTitle && (
        <Typography
          sx={{
            mb: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
            pb: 0.5,
            textTransform: "uppercase",
            fontSize: "0.875rem",
            fontWeight: 600
          }}
        >
          {title}
        </Typography>
      )}

      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>{children}</Box>
    </Box>
  );
}
